import { useCallback, useEffect, useRef, useState } from 'react';
import { HOVER_DELAY_TIMEOUT, BLOCK_HOVER_TIMEOUT } from '../constants/SidebarConstants';
import { jsx as _jsx } from "react/jsx-runtime";
function withHoveringAndCollapsing(SidebarComponent) {
  const WrappedComponent = props => {
    const {
      defaultLocked
    } = props;
    const blockTimeoutRef = useRef();
    const hoverTimeoutRef = useRef();
    const [isLocked, setIsLocked] = useState(defaultLocked);
    const [isHovered, setIsHovered] = useState(false);
    const [blockHover, setBlockHover] = useState(false);
    const [deadZoneHovered, setDeadZoneHovered] = useState(false);
    useEffect(() => {
      setIsLocked(defaultLocked);
      return () => {
        if (hoverTimeoutRef.current) {
          clearTimeout(hoverTimeoutRef.current);
        }
        if (blockTimeoutRef.current) {
          clearTimeout(blockTimeoutRef.current);
        }
      };
    }, [blockTimeoutRef, defaultLocked, hoverTimeoutRef]);
    const mouseEnter = useCallback(() => {
      if (isLocked) return;
      hoverTimeoutRef.current = setTimeout(() => {
        setIsHovered(true);
      }, HOVER_DELAY_TIMEOUT);
    }, [isLocked]);
    const mouseLeave = useCallback(() => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      if (isHovered || deadZoneHovered) {
        setIsHovered(false);
        setDeadZoneHovered(false);
      }
    }, [deadZoneHovered, isHovered]);
    const deadZoneEnter = useCallback(() => setDeadZoneHovered(true), []);
    const deadZoneLeave = useCallback(() => setDeadZoneHovered(false), []);
    const toggleHover = useCallback(() => {
      blockTimeoutRef.current = setTimeout(() => {
        setBlockHover(false);
      }, BLOCK_HOVER_TIMEOUT);
      setBlockHover(true);
    }, []);
    const toggleLocked = useCallback(() => {
      setIsLocked(!isLocked);
    }, [isLocked]);
    const newProps = {
      isHovered: isHovered && !blockHover,
      showDeadZone: deadZoneHovered || !isHovered,
      shouldHover: isHovered && !blockHover && !deadZoneHovered,
      mouseEnter,
      mouseLeave,
      deadZoneEnter,
      deadZoneLeave,
      toggleHover,
      isLocked,
      toggleLocked
    };
    return /*#__PURE__*/_jsx(SidebarComponent, Object.assign({}, props, newProps));
  };
  WrappedComponent.displayName = 'withHoveringAndCollapsing';
  return WrappedComponent;
}
export default withHoveringAndCollapsing;